import { render, staticRenderFns } from "./MyProjectsOverviewTable.vue?vue&type=template&id=2efb681b&scoped=true"
import script from "./MyProjectsOverviewTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsOverviewTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsOverviewTable.vue?vue&type=style&index=0&id=2efb681b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb681b",
  null
  
)

export default component.exports